import { render, staticRenderFns } from "./CodesReferrals.vue?vue&type=template&id=68bf830f&scoped=true"
import script from "./CodesReferrals.vue?vue&type=script&lang=js"
export * from "./CodesReferrals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf830f",
  null
  
)

export default component.exports